import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {UserAdminComponent} from './user-admin/user-admin.component';
import {AdminComponent} from './admin.component';
import {CompaniesAdminComponent} from './companies-admin/companies-admin.component';
import {CreateUserComponent} from './user-admin/create-user/create-user.component';
import {UserDetailsComponent} from './user-admin/user-details/user-details.component';
import {CompanyDetailsComponent} from './companies-admin/company-details/company-details.component';
import {CreateCompanyComponent} from './companies-admin/create-company/create-company.component';
import {CreateBranchComponent} from './companies-admin/branch-admin/create-branch/create-branch.component';
import {defaultGuards} from '../app-routing.module';
import {AdminSearchGuard} from '../_guards/admin-search.guard';
import {ViewCompanyGuard} from '../_guards/view-company.guard';
import {TuAdminGuard} from '../_guards/tu-admin.guard';
import {ViewUserGuard} from '../_guards/view-user.guard';
import {EditUserGuard} from '../_guards/edit-user.guard';
import {AddUserGuard} from '../_guards/add-user.guard';

const routes: Routes = [

  //"children" routes go to the AdminComponent's nested <router-outlet></router-outlet>
  //This module is lazy-loaded.  So every route in this routing module is a child route of admin
  {path: '', pathMatch: 'full', redirectTo: '/admin/users'},

  //Children that require being a TU Admin
  {
    path:     '', component: AdminComponent, canActivate: [...defaultGuards, TuAdminGuard],
    children: [
      {path: 'users/new', component: CreateUserComponent},
      {path: 'companies/new', component: CreateCompanyComponent},
      {path: 'companies/:companyName/edit', component: CreateCompanyComponent, data: {editing: true}},
      {path: 'companies/:companyName/add-user/admin', component: CreateUserComponent, data: {userType: 'admin'}},
      {path: 'companies/:companyName/branches/new', component: CreateBranchComponent},
      {path: 'companies/:companyName/branches/:branchId/edit', component: CreateBranchComponent, data: {editing: true}}
    ]
  },

  //Children that also allow other situations, such as being the company admin or an operator (see individual route guards for which)
  {
    path:     '', component: AdminComponent, canActivate: defaultGuards,
    children: [
      /* TU Admin or Operator */
      {path: 'users', component: UserAdminComponent, canActivate: [AdminSearchGuard]},
      /* Company Admin or Operator */
      {path: 'users/:userId/details', component: UserDetailsComponent, canActivate: [ViewUserGuard], data: {guardMode: 'user'}},
      /* Company Admin */
      {path: 'users/:userId/edit', component: CreateUserComponent, canActivate: [EditUserGuard], data: {editing: true, guardMode: 'user'}},
      /* TU Admin or Operator */
      {path: 'companies', component: CompaniesAdminComponent, canActivate: [AdminSearchGuard]},
      /* Company Admin or Operator */
      {path: 'companies/:companyName/details', component: CompanyDetailsComponent, canActivate: [ViewCompanyGuard],
        children: [
          {path: '', redirectTo: 'branches', pathMatch: 'full'},
          {path: ':tab', component: CompanyDetailsComponent}
        ]
      },
      /* Company Admin */
      {path: 'companies/:companyName/add-user/user', component: CreateUserComponent, canActivate: [AddUserGuard], data: {userType: 'user', guardMode: 'company'}}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule {}
